<template>
  <div :class="classes">
      <el-radio-group v-model="crrentValue" @change="change" :disabled="disabled">
        <el-radio v-for="(item,index) in radios" :key="index" :disabled="item.disabled" :border="item.border" :label="item.value">{{item.label}}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-radio'

export default {
  name: 'wt-radio',
  props: {
    value: {
      type: [Object, String, Boolean],
      default: ''
    },
    radios: {
      type: Array,
      default: function () {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      crrentValue: this.value
    }
  },
  watch: {
    value (val) {
      this.crrentValue = val
    }
  },
  methods: {
    change (val) {
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
